<template>

<div class="container wc-container" >
  <Row>
    <Col>
    <Select v-model="filter" style="width:150px; float:left;" @on-change="updateFilter">
      <Option value="inbox">Inbox</Option>
      <Option value="archive">Archive</Option>
      <Option value="trash">Trash</Option>
    </Select>
    <div style="float:right;">
      <div style="display:inline-block; margin-right:8px;     width: 140px;">
        <span style="vertical-align: middle;">Moderation</span>
        <i-switch size="large" v-model="moderation" @on-change="toggleModeration">
          <span slot="open">ON</span>
          <span slot="close">OFF</span>
        </i-switch>
      </div>
      <div style="display:inline-block; margin-right:8px; width: 160px;">
        <span style="vertical-align: middle;">Show on Page</span>
        <i-switch size="large" v-model="showQuestions" @on-change="toggleQuestionVisibility">
          <span slot="open">ON</span>
          <span slot="close">OFF</span>
        </i-switch>
      </div>
      <div style="display:inline-block; margin-right:8px; width: 220px;">
        <span style="vertical-align: middle;">Anonymous Questions</span>
        <i-switch size="large" v-model="qnaAnonymous" @on-change="toggleQnaAnonymous">
          <span slot="open">ON</span>
          <span slot="close">OFF</span>
        </i-switch>
      </div>

      <Button @click="newQuestionModal">Send a Question</Button>
    </div>
    </Col>
  </Row>
  <Loader v-if="!isReady"/>
  <div class="qna-list" v-if="isReady">
    <div v-if="questions.data.length<=0" style="max-width:720px; margin:auto;">
      <Alert type="info" show-icon style="margin-top:64px; " class="ivu-alert-with-desc">
          We don't have any questions yet
      </Alert>
      <p style="text-align:center; margin-top:64px;"></p>
    </div>

    <ul class="list-group lc-default-list-group" style="margin-top:48px;">
      <li class="list-group-item" v-for="q in questions.data" :key="q._id">
        <Row>
          <Col span="18">
          <div class="list-group-item-text" style="margin-top: 20px; margin-bottom: 20px;">
            <p class="item-subtext">{{q.name}} - {{q.location}} - {{q.createdAt | moment('DD.MM.YYYY HH:mm:ss')}}</p>
            <p>{{q.text}}</p>
          </div>
          </Col>
          <Col span="6" style="float:right">
          <Tooltip content="Delete" style="float:right" placement="top">
            <Button type="text" icon="md-trash" @click="moveToBucketQna(q._id, 'trash')" v-show="filter!='trash'"></Button>
          </Tooltip>
          <Tooltip content="Send to archive" style="float:right" placement="top">
            <Button type="text"  icon="md-archive" @click="moveToBucketQna(q._id, 'archive')" v-show="filter=='inbox'"></Button>
          </Tooltip>
          <Tooltip content="Move to inbox" style="float:right" placement="top">
            <Button type="text"  icon="md-share-alt" @click="moveToBucketQna(q._id, 'inbox')" v-show="filter!='inbox'"></Button>
          </Tooltip>
          <Tooltip style="float:right" placement="top">
            <div slot="content" v-if="!q.isApproved">Click to approve</div>
            <div slot="content" v-if="q.isApproved">Click to un-approve</div>
            <Button type="text" icon="md-checkbox-outline" @click="changeApproveQna(q._id, true)" v-if="filter!='trash' && !q.isApproved"></Button>
            <Button type="text" class="success" icon="md-checkbox-outline" @click="changeApproveQna(q._id, false)" v-if="filter!='trash' && q.isApproved"></Button>
          </Tooltip>
          </Col>
        </Row>

      </li>
    </ul>

  </div>

  <Modal v-model="isSendQnaActive" title="Send a question" @on-ok="newQuestion(form)" ok-text="Send" width="640">
    <Form :model="form" label-position="top">
      <Row :gutter="16">
        <Col span="12">
        <FormItem label="Name">
          <Input v-model="form.name" placeholder=""></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="Location">
          <Input v-model="form.location" placeholder=""></Input>
        </FormItem>
        </Col>
      </Row>
      <FormItem label="Question">
        <Input type="textarea" :rows="3" v-model="form.text" placeholder=""></Input>
      </FormItem>
    </Form>
  </Modal>
</div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'

import NewQuestionModal from '@/components/webcast/NewQuestionModal.vue'
import Loader from '@/components/base/Loader.vue'
import feathersClient from '../../api/feathers-client'

export default {
  data() {
    return {
      bucket: "inbox",
      form: {},
      isSendQnaActive: false,
      filter: "inbox",
      moderation: true,
      showQuestions: false,
      qnaAnonymous: false,
      page: {},
      isReady: false
    }
  },
  components: {
    Loader
  },
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('qna', {
      findQuestionsInStore: 'find'
    }),
    questions() {
      let query = {
        webcastId: this.webcast._id,
        bucket: this.filter,
        $sort: {
          createdAt: -1
        }
      }
      let res = this.findQuestionsInStore({
        query: query
      })
      return res
    }
  },
  created() {
    this.getQuestionList({}, 1);
    this.$data.moderation = this.webcast.qnaModeration;
    this.$data.showQuestions = this.webcast.qnaShowQuestions;
    this.$data.qnaAnonymous = this.webcast.qnaAnonymous;
    let self = this;
    feathersClient.io.on('connect', function() {
      self.getQuestionList({},1);
    });
  },
  methods: {
    ...mapActions('qna', {
      questionList: 'find',
      createQuestion: 'create',
      patchQuestionAction: 'patch'
    }),
    ...mapActions('webcast', {
      patchWebcastAction: 'patch'
    }),
    changePage(page){
      this.questions(page);
    },
    getQuestionList(query, page) {
      this.isReady=false;
      query.webcastId = this.webcast._id;
      query.bucket = this.filter
      this.questionList({query: query}).then(res=>{
        this.isReady=true;
      });
    },
    /*
    getQuestionList(query, page) {
      this.isReady=false;
      this.$store.commit('qna/clearAll');
      query.webcastId = this.webcast._id;
      query.bucket = this.filter
      query.$limit = 5;
      query.$skip = (page - 1) * query.$limit;
      query.$sort= {
        createdAt: -1
      }
      console.log(query);
      this.questionList({
        query: query
      }).then((response) => {
        console.log(response);
        if (response.data) {
          //let skip = response.skip+1
          let page = Math.round(query.$skip / response.limit)+1

          this.$set(this.$data, 'page', {
            current: page,
            skip: query.$skip,
            total: response.total
          });
          this.isReady=true;
        }
      });
    },
    */
    newQuestionModal() {
      this.isSendQnaActive = true;
    },
    newQuestion(data) {
      data.webcastId = this.webcast._id;
      data.bucket = "inbox"
      if(this.webcast.qnaModeration){
        data.isApproved = false;
      } else {
        data.isApproved = true;
      }
      data.isAnswered = false

      this.createQuestion(data).then((response) => {
        this.$Message.success('Your question has been sent');
        this.isSendQnaActive = false;
      });
    },
    changeApproveQna(qId, isApproved) {
      const payload = {
        isApproved: isApproved
      }
      this.patchQuestionAction([qId, payload, {}]).then((response) => {
        if (isApproved) {
          this.$Message.success("Question has been approved");
        } else {
          this.$Message.success("Question has been un-approved");
        }

      }).catch((error) => {
        this.$Message.error("Can't appove question. Error occured");
        console.log(error);
      })
    },
    moveToBucketQna(qId, bucket) {
      const payload = {
        bucket: bucket
      }
      this.patchQuestionAction([qId, payload, {}]).then((response) => {
        this.$Message.success("Question has been moved.");
      }).catch((error) => {
        this.$Message.error("Can't update question. Error occured");
        console.log(error);
      })
    },
    updateFilter() {
      this.getQuestionList({},1);
    },
    toggleQuestionVisibility(){
      const payload = {
        qnaShowQuestions: this.showQuestions
      }

      this.patchWebcastAction([this.webcast._id, payload, {}]).catch((error)=>{
        this.$Message.error("Can't update! error occured");
        console.log(error);
      })
    },
    toggleModeration(){
      const payload = {
        qnaModeration: this.moderation
      }

      this.patchWebcastAction([this.webcast._id, payload, {}]).catch((error)=>{
        this.$Message.error("Can't change moderation, error occured");
        console.log(error);
      })
    },
    toggleQnaAnonymous(){
      const payload = {
        qnaAnonymous: this.qnaAnonymous
      }

      this.patchWebcastAction([this.webcast._id, payload, {}]).catch((error)=>{
        this.$Message.error("Can't change qna features, error occured");
        console.log(error);
      })
    },


  }
}
</script>

<style>

</style>
